import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import { useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';

export default function ModaleDeleteCfp({ showDeleteCfp, closeModalDeleteCfp,idModule,onDeleteSuccess }) {
    const { token } = useStateContext();
    const [isLoggingOutGlobal, setIsLoggingOutGlobal] = useState(false);
      const { ModuleComptes } = useStateContext();

    if (!showDeleteCfp) return null;

    // suppression définitivement
    const handleDeleteCfp = async () => {
        setIsLoggingOutGlobal(true)
        console.log("idModule:", idModule);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            const response = await axios.delete(`https://catalogue.mg.formafusion.io/api/cfp/modules/${idModule}/destroy`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });

            if (response.data.status === 200) {
                toast.success("Suppression réussie");
                ModuleComptes();
                onDeleteSuccess(idModule);
                closeModalDeleteCfp();
            } else {
                toast.error(response.data.message );
                console.log("suppression impossible:", response.data.error)
            }

        } catch (error) {
            toast.error("Erreur lors de la suppression ");
        }finally{
            setIsLoggingOutGlobal(false)
        }
    };


    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="fixed top-0 left-0 w-full  bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center px-4 h-[99vh]">
                <div className="bg-white shadow-xl rounded-2xl w-full max-w-md p-6 animate-fade-in-up ">
                    <h2 className="text-xl font-semibold text-center text-gray-800 mb-4">
                        Confirmer la Suppression
                    </h2>
                    <p className="text-sm text-gray-600 text-center mb-6">
                        Êtes-vous sûr de vouloir supprimer définitivement ?
                    </p>
                    <div className="flex justify-end gap-4">
                        <button
                            onClick={closeModalDeleteCfp}
                            className="px-4 py-2 rounded-lg text-sm font-medium border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                        >
                            Annuler
                        </button>
                        <button
                            className="bg-[#8E548E] text-[#D0D8FD] px-6 py-2 rounded-lg text-sm font-semibold flex items-center justify-center"
                            onClick={handleDeleteCfp}
                            disabled={isLoggingOutGlobal}
                        >
                            {isLoggingOutGlobal ? (
                                <FaSpinner className="animate-spin w-5 h-5" />
                            ) : (
                                "Oui, confirmer"
                            )}
                        </button>

                    </div>
                </div>
            </div>
        </>
    );
}
